// extracted by mini-css-extract-plugin
export var articleContent = "article-content-module--article-content--c8a42";
export var center = "article-content-module--center--f1586";
export var container = "article-content-module--container--c879a";
export var descriptionContent = "article-content-module--description-content--f7bfb";
export var sourceText = "article-content-module--sourceText--24d64";